var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quote-message", on: { click: _vm.gotoReply } },
    [
      _c("div", { staticClass: "author" }, [
        _vm._v("\n        " + _vm._s(_vm.getAuthor()) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.isImageMessage()
        ? _c(
            "div",
            { staticClass: "image" },
            [
              _vm.fileSrc()
                ? _c(
                    "viewer",
                    {
                      attrs: {
                        id: "imageViewer-" + _vm.getId(),
                        images: [_vm.fileSrc()],
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end' }",
                            },
                          ],
                          staticClass: "cb-img-preview",
                          attrs: { content: _vm.$t("chatbotv2.imageView") },
                          on: {
                            click: function ($event) {
                              return _vm.showImage()
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass:
                              "img-thumbnail ant-upload-list-picture-card-container",
                            staticStyle: { "object-fit": "cover" },
                            attrs: {
                              id: "img-" + _vm.getId(),
                              src: _vm.fileSrc(),
                            },
                          }),
                          _vm._v(" "),
                          _vm.imageHovered
                            ? _c("md-icon", { staticClass: "cb-pr-icon" }, [
                                _vm._v(" visibility"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFileMessage()
        ? _c("div", { staticClass: "file" }, [
            _c("div", { staticClass: "media-content-wrapper" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  attrs: {
                    href: _vm.fileSrc(),
                    download: "",
                    target: "_blank",
                    content: "Dosyayı indir",
                  },
                },
                [
                  _vm.getExt()
                    ? _c(
                        "div",
                        { staticClass: "fi", class: "fi-" + _vm.getExt() },
                        [
                          _c("div", { staticClass: "fi-content" }, [
                            _vm._v(_vm._s(_vm.getExt())),
                          ]),
                        ]
                      )
                    : _c("a-icon", { attrs: { type: "cloud-download" } }),
                  _vm._v(" "),
                  _c("p", { staticClass: "asset-text" }, [
                    _vm._v(_vm._s(_vm.getAssetName())),
                  ]),
                ],
                1
              ),
            ]),
          ])
        : _c("div", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(_vm.getText()) },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }